module.exports = __webpack_public_path__ + "static/img/fangan_banner@2x.81113209.jpg";